import { baseApi } from './baseApi';

/**
 * References API endpoints
 * Handles reference data (person types, address types, proposal statuses, etc.)
 */
export const referencesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /references/:referenceType - Fetch reference data by type
    getReferences: builder.query({
      query: (referenceType) => `/references/${referenceType}`,
      providesTags: (result, error, referenceType) => [{ type: 'Reference', id: referenceType }],
    }),

    // Convenience endpoints for common reference types
    getPersonTypes: builder.query({
      query: () => '/references/person_type',
      providesTags: [{ type: 'Reference', id: 'person_type' }],
    }),

    getAddressTypes: builder.query({
      query: () => '/references/address_type',
      providesTags: [{ type: 'Reference', id: 'address_type' }],
    }),

    getProposalStatuses: builder.query({
      query: () => '/references/proposal_status',
      providesTags: [{ type: 'Reference', id: 'proposal_status' }],
    }),
  }),
});

// Export hooks for use in components
export const {
  useGetReferencesQuery,
  useGetPersonTypesQuery,
  useGetAddressTypesQuery,
  useGetProposalStatusesQuery,
} = referencesApi;

